export default {
  path: "/safe",
  redirect: "/safe/ranking",
  meta: {
    title: "质安部",
    permissionCode: "",
  },
  children: [
    {
      path: "ranking",
      meta: {
        title: "月度质安考评排名",
        permissionCode: "pcQualityRanking",
      },
      component: () => import("@/views/safe/monthlyRanking/index.vue"),
    },
    // {
    //   path: "monthlyInspection",
    //   redirect: "/safe/monthlyInspection/project",
    //   meta: {
    //     title: "月度检查管理",
    //     permissionCode: "",
    //   },
    //   component: () => import("@/router/EmptyComponent.vue"),
    //   children: [

    //   ],
    // },
    {
      path: "/safe/monthlyInspection/project",
      meta: {
        title: "月度检查项目综合评分",
        permissionCode: "pcQualityProject",
        keepAlive: true,
        name: "pcQualityProject",

        state: "edit",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/project/detail.vue"),
    },

    /****************************************************************
     *
     * @实测实量检查评分
     *
     ***************************************************************/

    {
      path: "/safe/monthlyInspection/measure",
      meta: {
        title: "实测实量检查评分",
        permissionCode: "pcQualityMeasure",
        keepAlive: true,
        name: "pcQualityMeasure",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/measure/list.vue"),
    },
    {
      path: "/safe/monthlyInspection/addMeasureDetail",
      meta: {
        title: "添加实测实量检查评分",
        permissionCode: "pcQualityMeasure",

        state: "add",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/measure/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/editMeasureDetail",
      meta: {
        title: "修改实测实量检查评分",
        permissionCode: "pcQualityMeasure",

        state: "edit",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/measure/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/copyMeasureDetail",
      meta: {
        title: "复制实测实量检查评分",
        permissionCode: "pcQualityMeasure",

        state: "copy",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/measure/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/lookMeasureDetail",
      meta: {
        title: "复制实测实量检查评分",
        permissionCode: "pcQualityMeasure",

        state: "look",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/measure/detail.vue"),
    },

    /****************************************************************
     *
     * @质量风险检查评分
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/risk",
      meta: {
        title: "质量风险检查评分",
        permissionCode: "pcQualityRisk",
        keepAlive: true,
        name: "pcQualityRisk",
      },
      component: () => import("@/views/safe/monthlyInspection/risk/list.vue"),
    },
    {
      path: "/safe/monthlyInspection/addRiskDetail",
      meta: {
        title: "添加质量风险检查评分",
        permissionCode: "pcQualityRisk",

        state: "add",
      },
      component: () => import("@/views/safe/monthlyInspection/risk/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/editRiskDetail",
      meta: {
        title: "修改质量风险检查评分",
        permissionCode: "pcQualityRisk",

        state: "edit",
      },
      component: () => import("@/views/safe/monthlyInspection/risk/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/copyRiskDetail",
      meta: {
        title: "复制质量风险检查评分",
        permissionCode: "pcQualityRisk",

        state: "copy",
      },
      component: () => import("@/views/safe/monthlyInspection/risk/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/lookRiskDetail",
      meta: {
        title: "查看质量风险检查评分",
        permissionCode: "pcQualityRisk",

        state: "look",
      },
      component: () => import("@/views/safe/monthlyInspection/risk/detail.vue"),
    },

    /****************************************************************
     *
     * @安全文明施工检查评分
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/civilization",
      meta: {
        title: "安全文明施工检查评分",
        permissionCode: "pcQualityCivilization",
        keepAlive: true,
        name: "pcQualityCivilization",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/civilization/list.vue"),
    },
    {
      path: "/safe/monthlyInspection/addCivilizationDetail",
      meta: {
        title: "添加安全文明施工检查评分",
        permissionCode: "pcQualityCivilization",

        state: "add",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/civilization/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/editCivilizationDetail",
      meta: {
        title: "修改安全文明施工检查评分",
        permissionCode: "pcQualityCivilization",

        state: "edit",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/civilization/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/copyCivilizationDetail",
      meta: {
        title: "复制安全文明施工检查评分",
        permissionCode: "pcQualityCivilization",

        state: "copy",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/civilization/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/lookCivilizationDetail",
      meta: {
        title: "查看安全文明施工检查评分",
        permissionCode: "pcQualityCivilization",

        state: "look",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/civilization/detail.vue"),
    },

    /****************************************************************
     *
     * @项目资料检查评分
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/datas",
      meta: {
        title: "项目资料检查评分",
        permissionCode: "pcQualityDatas",
        keepAlive: true,
        name: "pcQualityDatas",
      },
      component: () => import("@/views/safe/monthlyInspection/datas/list.vue"),
    },
    {
      path: "/safe/monthlyInspection/addDatasDetail",
      meta: {
        title: "添加项目资料检查评分",
        permissionCode: "pcQualityDatas",

        state: "add",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/datas/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/editDatasDetail",
      meta: {
        title: "修改项目资料检查评分",
        permissionCode: "pcQualityDatas",

        state: "edit",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/datas/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/copyDatasDetail",
      meta: {
        title: "复制项目资料检查评分",
        permissionCode: "pcQualityDatas",

        state: "copy",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/datas/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/lookDatasDetail",
      meta: {
        title: "查看项目资料检查评分",
        permissionCode: "pcQualityDatas",

        state: "look",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/datas/detail.vue"),
    },

    /****************************************************************
     *
     * @项目材料检查评分
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/material",
      meta: {
        title: "项目材料检查评分",
        permissionCode: "pcQualityMaterial",
        keepAlive: true,
        name: "pcQualityMaterial",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/material/list.vue"),
    },
    {
      path: "/safe/monthlyInspection/addMaterialDetail",
      meta: {
        title: "添加项目材料检查评分",
        permissionCode: "pcQualityMaterial",

        state: "add",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/material/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/editMaterialDetail",
      meta: {
        title: "修改项目材料检查评分",
        permissionCode: "pcQualityMaterial",

        state: "edit",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/material/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/copyMaterialDetail",
      meta: {
        title: "复制项目材料检查评分",
        permissionCode: "pcQualityMaterial",

        state: "copy",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/material/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/lookDatasDetail",
      meta: {
        title: "复制项目材料检查评分",
        permissionCode: "pcQualityMaterial",

        state: "look",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/material/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/projectConf",
      redirect: "/safe/monthlyInspection/projectConf/measure",
      meta: {
        title: "检查项配置",
        permissionCode: "pcQualityProjectConf",
        name: "pcQualityProjectConf",
        keepAlive: true,
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/nav.vue"),
      children: [
        {
          path: "/safe/monthlyInspection/projectConf/measure",
          meta: {
            title: "实测实量检查",
            name: "measure",
            permissionCode: "pcQualityProjectConf",
          },
          component: () =>
            import(
              "@/views/safe/monthlyInspection/projectConf/measure/list.vue"
            ),
        },
        {
          path: "/safe/monthlyInspection/projectConf/risk",
          meta: {
            title: "质量风险检查",
            name: "risk",
            permissionCode: "pcQualityProjectConf",
          },
          component: () =>
            import("@/views/safe/monthlyInspection/projectConf/risk/list.vue"),
        },
        {
          path: "/safe/monthlyInspection/projectConf/civilization",
          meta: {
            title: "安全文明检查",
            name: "civilization",
            permissionCode: "pcQualityProjectConf",
          },
          component: () =>
            import(
              "@/views/safe/monthlyInspection/projectConf/civilization/list.vue"
            ),
        },
        {
          path: "/safe/monthlyInspection/projectConf/datas",
          meta: {
            title: "项目资料检查",
            name: "datas",
            permissionCode: "pcQualityProjectConf",
          },
          component: () =>
            import("@/views/safe/monthlyInspection/projectConf/datas/list.vue"),
        },
        {
          path: "/safe/monthlyInspection/projectConf/material",
          meta: {
            title: "项目材料检查",
            name: "material",
            permissionCode: "pcQualityProjectConf",
          },
          component: () =>
            import(
              "@/views/safe/monthlyInspection/projectConf/material/list.vue"
            ),
        },
        {
          path: "/safe/monthlyInspection/projectConf/hardcoverAssessment",
          meta: {
            title: "项目验收评估检查-精装",
            name: "hardcover",
            permissionCode: "pcQualityProjectConf",
            state: "hardcover",
          },
          component: () =>
            import(
              "@/views/safe/monthlyInspection/projectConf/assessment/list.vue"
            ),
        },
        {
          path: "/safe/monthlyInspection/projectConf/commonAssessment",
          meta: {
            title: "项目验收评估检查-公共",
            name: "common",
            permissionCode: "pcQualityProjectConf",

            state: "common",
          },
          component: () =>
            import(
              "@/views/safe/monthlyInspection/projectConf/assessment/list.vue"
            ),
        },
        {
          path: "/safe/monthlyInspection/projectConf/facadeAssessment",
          meta: {
            title: "项目验收评估检查-外立面",
            name: "facade",
            permissionCode: "pcQualityProjectConf",

            state: "facade",
          },
          component: () =>
            import(
              "@/views/safe/monthlyInspection/projectConf/assessment/list.vue"
            ),
        },
        {
          path: "/safe/monthlyInspection/projectConf/node",
          meta: {
            title: "强节点检查",
            name: "node",
            permissionCode: "pcQualityProjectConf",
            state: "node",
          },
          component: () =>
            import("@/views/safe/monthlyInspection/projectConf/node/list.vue"),
        },
      ],
    },

    /****************************************************************
     *
     * @添加检查实测实量
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/addTermProjectMeasure",
      meta: {
        title: "添加检查项 实测实量",
        permissionCode: "pcQualityProjectConf",

        state: "addTerm",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/measure/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/editTermProjectMeasure",
      meta: {
        title: "添加检查项 实测实量",
        permissionCode: "pcQualityProjectConf",

        state: "editTerm",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/measure/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/addContentProjectMeasure",
      meta: {
        title: "添加检查内容 实测实量",
        permissionCode: "pcQualityProjectConf",

        state: "addContent",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/measure/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/editContentProjectMeasure",
      meta: {
        title: "修改检查内容 实测实量",
        permissionCode: "pcQualityProjectConf",

        state: "editContent",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/measure/detail.vue"),
    },

    /****************************************************************
     *
     * @添加检查质量风险
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/addTermProjectRisk",
      meta: {
        title: "添加检查项 质量风险",
        permissionCode: "pcQualityProjectConf",

        state: "addTerm",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/risk/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/addContentProjectRisk",
      meta: {
        title: "添加检查内容 质量风险",
        permissionCode: "pcQualityProjectConf",

        state: "addContent",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/risk/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/editContentProjectRisk",
      meta: {
        title: "修改检查内容 质量风险",
        permissionCode: "pcQualityProjectConf",

        state: "editContent",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/risk/detail.vue"),
    },

    /****************************************************************
     *
     * @添加检查安全文明
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/addTermProjectCivilization",
      meta: {
        title: "添加检查项 安全文明",
        permissionCode: "pcQualityProjectConf",

        state: "addTerm",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/civilization/detail.vue"
        ),
    },
    {
      path: "/safe/monthlyInspection/addContentProjectCivilization",
      meta: {
        title: "添加检查内容 安全文明",
        permissionCode: "pcQualityProjectConf",

        state: "addContent",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/civilization/detail.vue"
        ),
    },
    {
      path: "/safe/monthlyInspection/editContentProjectCivilization",
      meta: {
        title: "修改检查内容 安全文明",
        permissionCode: "pcQualityProjectConf",

        state: "editContent",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/civilization/detail.vue"
        ),
    },

    /****************************************************************
     *
     * @添加检查项目资料
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/addTermProjectDatas",
      meta: {
        title: "添加检查项 项目资料",
        permissionCode: "pcQualityProjectConf",

        state: "addTerm",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/datas/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/addContentProjectDatas",
      meta: {
        title: "添加检查内容 项目资料",
        permissionCode: "pcQualityProjectConf",

        state: "addContent",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/datas/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/editContentProjectDatas",
      meta: {
        title: "修改检查内容 项目资料",
        permissionCode: "pcQualityProjectConf",

        state: "editContent",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/datas/detail.vue"),
    },

    /****************************************************************
     *
     * @添加检查项目材料
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/addTermProjectMaterial",
      meta: {
        title: "添加检查项 项目材料",
        permissionCode: "pcQualityProjectConf",

        state: "addTerm",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/material/detail.vue"
        ),
    },
    {
      path: "/safe/monthlyInspection/addContentProjectMaterial",
      meta: {
        title: "添加检查内容 项目材料",
        permissionCode: "pcQualityProjectConf",

        state: "addContent",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/material/detail.vue"
        ),
    },
    {
      path: "/safe/monthlyInspection/editContentProjectMaterial",
      meta: {
        title: "添加检查内容 项目材料",
        permissionCode: "pcQualityProjectConf",

        state: "editContent",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/material/detail.vue"
        ),
    },

    /****************************************************************
     *
     * @项目验收精装
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/addTermProjectHardcover",
      meta: {
        title: "添加检查项验收评估-精装",
        permissionCode: "pcQualityProjectConf",

        state: "addTerm",
        CHECK_TYPE: "05",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/assessment/detail.vue"
        ),
    },
    {
      path: "/safe/monthlyInspection/addContentProjectHardcover",
      meta: {
        title: "添加检查内容验收评估-精装",
        permissionCode: "pcQualityProjectConf",

        state: "addContent",
        CHECK_TYPE: "05",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/assessment/detail.vue"
        ),
    },
    {
      path: "/safe/monthlyInspection/editContentProjectHardcover",
      meta: {
        title: "修改检查内容验收评估-精装",
        permissionCode: "pcQualityProjectConf",

        state: "editContent",
        CHECK_TYPE: "05",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/assessment/detail.vue"
        ),
    },

    /****************************************************************
     *
     * @项目验收公区
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/addTermProjectCommon",
      meta: {
        title: "添加检查项验收评估-公区",
        permissionCode: "pcQualityProjectConf",

        state: "addTerm",
        CHECK_TYPE: "06",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/assessment/detail.vue"
        ),
    },
    {
      path: "/safe/monthlyInspection/addContentProjectCommon",
      meta: {
        title: "添加检查内容验收评估-公区",
        permissionCode: "pcQualityProjectConf",

        state: "addContent",
        CHECK_TYPE: "06",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/assessment/detail.vue"
        ),
    },
    {
      path: "/safe/monthlyInspection/editContentProjectCommon",
      meta: {
        title: "添加检查内容验收评估-公区",
        permissionCode: "pcQualityProjectConf",

        state: "editContent",
        CHECK_TYPE: "06",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/assessment/detail.vue"
        ),
    },

    /****************************************************************
     *
     * @项目验收外立面
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/addTermProjectFacade",
      meta: {
        title: "添加检查项验收评估-外立面",
        permissionCode: "pcQualityProjectConf",

        state: "addTerm",
        CHECK_TYPE: "07",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/assessment/detail.vue"
        ),
    },
    {
      path: "/safe/monthlyInspection/addContentProjectFacade",
      meta: {
        title: "添加检查内容验收评估-外立面",
        permissionCode: "pcQualityProjectConf",

        state: "addContent",
        CHECK_TYPE: "07",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/assessment/detail.vue"
        ),
    },
    {
      path: "/safe/monthlyInspection/editContentProjectFacade",
      meta: {
        title: "修改检查内容验收评估-外立面",
        permissionCode: "pcQualityProjectConf",

        state: "editContent",
        CHECK_TYPE: "07",
      },
      component: () =>
        import(
          "@/views/safe/monthlyInspection/projectConf/assessment/detail.vue"
        ),
    },

    /****************************************************************
     *
     * @项目验收添加强节点
     *
     ***************************************************************/
    {
      path: "/safe/monthlyInspection/addProjectNode",
      meta: {
        title: "添加强节点",
        permissionCode: "pcQualityProjectConf",

        state: "add",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/node/detail.vue"),
    },
    {
      path: "/safe/monthlyInspection/editProjectNode",
      meta: {
        title: "修改强节点",
        permissionCode: "pcQualityProjectConf",

        state: "edit",
      },
      component: () =>
        import("@/views/safe/monthlyInspection/projectConf/node/detail.vue"),
    },

    {
      path: "nodeInspectionList",
      meta: {
        title: "强管节点检查管理",
        permissionCode: "pcQualityNode",
        name: "pcQualityNode",
        keepAlive: true,
      },
      component: () => import("@/views/safe/nodeInspection/list.vue"),
    },
    {
      path: "detailScore",
      meta: {
        title: "强管节点检查管理评分",
        permissionCode: "pcQualityNode",
        name: "pcQualityNodeSample",
        keepAlive: true,
        state: "score",
      },
      component: () => import("@/views/safe/nodeInspection/detailSample.vue"),
    },
    {
      path: "detailLook",
      meta: {
        title: "查看强管节点检查管理评分",
        permissionCode: "pcQualityNode",
        name: "pcQualityNodeSample",
        keepAlive: true,
        state: "look",
      },
      component: () => import("@/views/safe/nodeInspection/detailSample.vue"),
    },
    {
      path: "rewardsPunishmentsList",
      meta: {
        title: "质安奖惩管理",
        permissionCode: "pcQualityRewardsPunishments",
        name: "pcQualityRewardsPunishments",
        keepAlive: true,
      },
      component: () => import("@/views/safe/rewardsPunishments/list.vue"),
    },
    {
      path: "addRewardsPunishments",
      meta: {
        title: "新增、修改质安奖惩管理",
        permissionCode: "pcQualityRewardsPunishments",

        state: "add",
      },
      component: () => import("@/views/safe/rewardsPunishments/details.vue"),
    },
    {
      path: "authRewardsPunishments",
      meta: {
        title: "审核质安奖惩管理",
        permissionCode: "pcQualityRewardsPunishments",

        state: "look",
      },
      component: () => import("@/views/safe/rewardsPunishments/auth.vue"),
    },
    {
      path: "studyList",
      meta: {
        title: "交流学习管理",
        permissionCode: "pcQualityStudy",
        name: "pcQualityStudy",
        keepAlive: true,
      },
      component: () => import("@/views/safe/study/list.vue"),
    },
    {
      path: "addStudy",
      meta: {
        title: "添加、修改交流学习管理",
        permissionCode: "pcQualityStudy",

        state: "add",
      },
      component: () => import("@/views/safe/study/add.vue"),
    },
    {
      path: "detailStudy",
      meta: {
        title: "交流学习管理详情",
        permissionCode: "pcQualityStudy",

        state: "edit",
      },
      component: () => import("@/views/safe/study/detail.vue"),
    },
    {
      path: "fineCaseList",
      meta: {
        title: "优秀案例分享管理",
        permissionCode: "pcQualityCase",
        name: "pcQualityCase",
        keepAlive: true,
      },
      component: () => import("@/views/safe/fineCase/list.vue"),
    },
    {
      path: "addFineCase",
      meta: {
        title: "添加、修改优秀案例分享管理",
        permissionCode: "pcQualityCase",

        state: "add",
      },
      component: () => import("@/views/safe/fineCase/add.vue"),
    },
    {
      path: "detailFineCase",
      meta: {
        title: "优秀案例分享管理详情",
        permissionCode: "pcQualityCase",

        state: "edit",
      },
      component: () => import("@/views/safe/fineCase/detail.vue"),
    },
  ],
};
